<template>
  <div class="footers">
    <div class="pc-wrap group-width df">
      <div class="left-con">
        <p class="fw6 title">关注我们</p>
        <ul v-if="isShowIcon" class="df aic icon-wrap">
          <li
            v-for="(item, index) in footerIcon"
            :key="index"
            :style="
              item.url && !item.hovered
                ? 'background-image:url(' + item.url + ')'
                : 'background-image:url(' + item.hoverUrl + ')'
            "
            class="fw6 cup icon-item"
            @mouseover="hoverIcon(index)"
            @mouseout="leaveIcon(index)"
          >
            <el-image class="code-img" :src="item.codeImg"></el-image>
          </li>
        </ul>
        <ul v-else class="icon-g">
          <li
            v-for="(item, index) in imgIcons"
            :key="index"
            class="icon-m cup"
            @click="goBank(item)"
          >
            <el-image :src="item.imgUrl" lazy alt="外链图标" />
          </li>
        </ul>
      </div>
      <div class="center-con">
        <ul class="df aic menu">
          <li
            v-for="(item, index) in footerMenu"
            :key="index"
            class="fw6 cup menu-item"
            @click="handleMenu(item)"
          >
            {{ item.name }}
          </li>
        </ul>
        <div class="tip">版权所有2026©光惠激光。沪ICP备17048378号</div>
      </div>
      <div class="right-con">
        <Subscribe />
        <div class="btm-w">
          <div class="info" :class="{ active: isShowIcon }">
            <p class="con-d">服务热线：4000-111-976</p>
            <p class="con-d">邮箱：sales@gwlaser.tech</p>
          </div>
          <p class="con-d">地址：上海市青浦区华新镇华志路1388号中交数字智造港8号楼1-3层</p>
        </div>
      </div>
    </div>
    <div class="group-width">
      <MFooter class="mobile-wrap" />
    </div>
    <div class="footer-m-b">
      <div class="group-width">
        版权所有2026©光惠激光。沪ICP备17048378号
      </div>
    </div>
  </div>
</template>

<script>
import MFooter from './components/mFooters.vue'
import Subscribe from './components/Subscribe.vue'
export default {
  name: 'FooterS',
  components: { MFooter, Subscribe },
  data() {
    return {
      email: '',
      footerIcon: [
        {
          title: '微信服务号',
          url: require('@/assets/images/footer-wechart.svg'),
          hoverUrl: require('@/assets/images/footer-wechart-fff.svg'),
          codeImg: require('@/assets/images/code-fuwu.webp'),
          hovered: false,
        },
        {
          title: '微信订阅号',
          url: require('@/assets/images/footer-wechart.svg'),
          hoverUrl: require('@/assets/images/footer-wechart-fff.svg'),
          codeImg: require('@/assets/images/code-ding.webp'),
          hovered: false,
        },
        {
          title: '微信视频号',
          url: require('@/assets/images/footer-wechartV.svg'),
          hoverUrl: require('@/assets/images/footer-wechartV-fff.svg'),
          codeImg: require('@/assets/images/code-wechartmini.webp'),
          hovered: false,
        },
        {
          title: '抖音',
          url: require('@/assets/images/footer-douyin.svg'),
          hoverUrl: require('@/assets/images/footer-douyin-fff.svg'),
          codeImg: require('@/assets/images/code-douyin.webp'),
          windowOpenUrl:
            'https://www.douyin.com/user/MS4wLjABAAAAr7flbN4g2SeRdevBUdbI4cUq_-7yB8so40ZIRIcBtYo',
          hovered: false,
        },
        {
          title: '微信小程序',
          url: require('@/assets/images/footer-wechart1.svg'),
          hoverUrl: require('@/assets/images/footer-wechart1-fff.svg'),
          codeImg: require('@/assets/images/code-wechartmini.webp'),
          hovered: false,
        },
        {
          title: '头条',
          url: require('@/assets/images/footer-toutiao.svg'),
          hoverUrl: require('@/assets/images/footer-toutiao-fff.svg'),
          codeImg: require('@/assets/images/code-toutiao.webp'),
          windowOpenUrl:
            'https://www.toutiao.com/c/user/token/MS4wLjABAAAAbUZGwKA_kcX2UDbN_UvwDJjk9GKqAg_Ob18s9p15fHZgKl8mLE5edevk0qsX5p9n/?',
          hovered: false,
        },
      ],
      footerMenu: [
        { name: '产品中心', path: 'https://www.gwlaser.tech/productCenter?idx=66N' },
        { name: '解决方案', path: 'https://www.gwlaser.tech/solution?idx=184N' },
        { name: '技术介绍', path: 'https://www.gwlaser.tech/technologies' },
        { name: '关于我们', path: 'https://www.gwlaser.tech/aboutUs' },
        { name: '技术支持', path: 'https://www.gwlaser.tech/support' },
        { name: '商城', path: 'https://shop.gwlaser.tech/' },
      ],
      imgIcons: [
        {
          imgUrl: require('@/assets/images/footer-e3.svg'),
          windowOpenUrl: 'https://www.facebook.com/121364670934497',
        },
        {
          imgUrl: require('@/assets/images/footer-e5.svg'),
          windowOpenUrl: 'https://x.com/GWlasertech976',
        },
        {
          imgUrl: require('@/assets/images/footer-e6.svg'),
          windowOpenUrl:
            'https://www.linkedin.com/company/gw-laser-technology-llc',
        },
        {
          imgUrl: require('@/assets/images/footer-e2.svg'),
          windowOpenUrl:
            'https://www.youtube.com/channel/UC8p14RR0bvmnnduf35_cTVA',
        },
        {
          imgUrl: require('@/assets/images/footer-e4.svg'),
          windowOpenUrl: 'https://www.instagram.com/gwlasertech976/',
        },
        {
          imgUrl: require('@/assets/images/footer-e1.svg'),
          windowOpenUrl: 'https://www.tiktok.com/@gwlasertech976',
        },
      ],
    }
  },
  computed: {
    isShowIcon() {
      return true
    },
  },
  methods: {
    hoverIcon(index) {
      this.footerIcon[index].hovered = true
    },
    leaveIcon(index) {
      this.footerIcon[index].hovered = false
    },
    handleMenu(item) {
      if (item.path) {
        // http/https 外链：新窗口打开
        if (/^https?:\/\//i.test(item.path)) {
          window.open(item.path, '_blank')
        } else {
          // 内部路由：使用 router 跳转
          this.$router.push({
            path: item.path,
          })
        }
      }
    },
    goBank(item) {
      if (item.windowOpenUrl) {
        window.open(item.windowOpenUrl, '_blank')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.footers {
  background: #0b193f;
  .pc-wrap {
    color: #fff;
    padding-top: 70px;
    padding-bottom: 50px;
    font-size: 15px;
  }
  .footer-m-b {
    display: none;
    color: #fff;
    font-size: 14px;
    padding: 20px 0;
    color: #e0e9ff;
    background: rgba(#fff, 0.1);
  }
  .mobile-wrap {
    display: none;
  }
  .left-con {
    width: 20%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      height: 42px;
      line-height: 42px;
      border-top: 1px solid rgba(#fff, 0.2);
      border-bottom: 1px solid rgba(#fff, 0.2);
    }
    .icon-item {
      display: inline-block;
      width: 35px;
      height: 35px;
      background-repeat: no-repeat;
      margin-right: 2px;
      position: relative;
      &:hover {
        .code-img {
          display: block;
          position: absolute;
          top: -72px;
          left: -15px;
          width: 70px;
          height: 70px;
        }
      }
    }
    .code-img {
      display: none;
    }
  }
  .icon-g {
    display: flex;
    .icon-m {
      margin-right: 15px;
      .el-image {
        width: 30px;
        height: 30px;
      }
    }
  }
  .center-con {
    width: 47%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .menu {
    width: 100%;
    height: 42px;
    border-top: 1px solid rgba(#fff, 0.2);
    border-bottom: 1px solid rgba(#fff, 0.2);
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .menu-item {
    flex: 1;
    text-align: center;
    position: relative;
    padding: 0 5px;
    &::after {
      content: '';
      display: inline-block;
      width: 1px;
      height: 14px;
      background: #fff;
      position: absolute;
      top: 50%;
      right: 0;
      margin-top: -7px;
    }
    &:last-child {
      &::after {
        width: 0;
        height: 0;
      }
    }
  }
  .tip {
    font-size: 14px;
    line-height: 24px;
    color: #e9edff;
    display: flex;
    justify-content: center;
  }
  .right-con {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .subscribe,
  .btm-w {
    width: 333px;
  }
  .info {
    width: 100%;
    margin-top: 20px;
    &.active {
      display: flex;
      justify-content: space-between;
      margin-bottom: 5px;
    }
  }
  .con-d {
    font-size: 14px;
    line-height: 24px;
    color: #e9edff;
  }
}
@media (min-width: 1200px) and (max-width: 1500px) {
  .footers {
    .pc-wrap {
      font-size: 13px;
    }
    .tip {
      font-size: 12px;
    }
    .center-con {
      width: 52%;
    }
    .subscribe,
    .btm-w {
      width: 280px;
    }
    .con-d {
      font-size: 12px;
    }
  }
}

@media (min-width: 1024px) and (max-width: 1200px) {
  .footers {
    .pc-wrap {
      display: none;
    }
    .mobile-wrap {
      display: block;
      padding: 30px 0;
    }
    .footer-m-b {
      display: block;
    }
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .footers {
    .pc-wrap {
      display: none;
    }
    .mobile-wrap {
      display: block;
    }
    .footer-m-b {
      display: block;
    }
  }
}
@media (max-width: 768px) {
  .footers {
    .pc-wrap {
      display: none;
    }
    .mobile-wrap {
      display: block;
    }
    .footer-m-b {
      display: block;
    }
  }
}
</style>